import { Button, ButtonProps } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { FeatureFlag, Id, PermissionRule } from "PFTypes";
import { useNavigate } from "react-router";

import { getCvExportsPath } from "./cv_exports_button.utils";

type CvExportsButtonProps = Pick<ButtonProps, "icon" | "kind" | "qaId" | "small" | "disabled" | "text"> & {
  profileIds: Id[];
  activityId?: Id;
  tooltipContent?: string;
};

export const CvExportsButton = ({
  profileIds,
  activityId,
  tooltipContent,
  ...buttonProps
}: CvExportsButtonProps) => {
  const navigate = useNavigate();
  const isEnabled = useIsFeatureEnabled();
  const isProfileExportEnabled = isEnabled(FeatureFlag.ProfileExporter);
  const canExportDocs = useIsCurrentUserPermittedTo(PermissionRule.ExportDocuments);

  if (!isProfileExportEnabled || !canExportDocs || profileIds.length === 0) {
    return null;
  }

  const button = (
    <Button
      icon="export"
      kind="secondary"
      {...buttonProps}
      onClick={() => navigate(getCvExportsPath(profileIds, activityId))}
    />
  );

  return tooltipContent ? (
    <Tooltip content={<Typography variant="bodyRegular">{tooltipContent}</Typography>}>{button}</Tooltip>
  ) : (
    button
  );
};
